import api from 'services/api';
import action from 'utils/action';
import checkError from 'utils/check-error';

export function filtersGetAll() { // eslint-disable-line
  return (dispatch) => {
    dispatch(action('FILTERS_GET_ALL_REQUEST'));

    return new Promise((resolve, reject) => {
      return api.get('/api/systems/filter-list').then((payload) => {
        if (checkError(payload)) {
          dispatch(action('FILTERS_GET_ALL_FAILURE', payload.json));
          reject();
        } else {
          dispatch(action('FILTERS_GET_ALL_SUCCESS', payload.json));
          resolve();
        }
      }).catch((payload) => {
        dispatch(action('FILTERS_GET_ALL_FAILURE', payload.json));
        reject();
      });
    });
  };
}




// WEBPACK FOOTER //
// ./js/actions/filters.js